import axios from 'axios';
import constants from '../constants';
// import authService from '../auth/AuthService'; // acquire token from getters['oidcStore/oidcAccessToken']
import moment from 'moment';
import { employees } from './devdata';
import AppUsersClient from "../clients/AppUsersClient";

const resource = '/gpsdata';

export default {
    getGPSDataList(dto) {
        return new Promise((resolve, reject) => {
            AppUsersClient.get(`${resource}/GetGPSDataBeforeGivenClock/${dto.assistantNumber}?fromdate=${moment(dto.fromDate).format('YYYY-MM-DD')}&todate=${moment(dto.toDate).format('YYYY-MM-DD')}`)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            });
        });
    },
    updateGPSData(gpsData){
        return new Promise((resolve, reject) => {
            AppUsersClient.put(`${resource}/Update`, gpsData)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                reject(error)
            });
        });
    }
}